// src/app/modules/adminrh/parametres/parametresJS/ProjetsTab.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Plus, Edit2, Trash2, X } from "lucide-react";
import {
    fetchAllProjetsRequest,
    createProjetRequest,
    updateProjetRequest,
    deleteProjetRequest
} from "../../../../redux/actions/projetActions";
import { getAllEntitesRequest } from "../../../../redux/actions/entitesActions";
import "../parametresStyles/ParamJT.css";

export default function ProjetsTab() {
    const dispatch = useDispatch();
    const { allProjets = [], loading } = useSelector(s => s.projets || {});
    const { entites = [] } = useSelector(s => s.entite || {});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [currentId, setCurrentId] = useState(null);

    const [formData, setFormData] = useState({
        code: "",
        nom: "",
        description: "",
        entityId: "",
        isActive: true
    });

    const getEntityLabel = (entity) => {
        if (!entity) return "";
        const label = entity.nom || entity.name || entity.entityNom || entity.entityName || entity.code;
        return entity.code && label && label !== entity.code ? `${entity.code} - ${label}` : label || `Entite ${entity.id}`;
    };

    useEffect(() => {
        dispatch(fetchAllProjetsRequest());
        dispatch(getAllEntitesRequest());
    }, [dispatch]);

    const openCreateModal = () => {
        setFormData({ code: "", nom: "", description: "", entityId: "", isActive: true });
        setEditMode(false);
        setCurrentId(null);
        setIsModalOpen(true);
    };

    const openEditModal = (proj) => {
        setFormData({
            code: proj.code || "",
            nom: proj.nom || "",
            description: proj.description || "",
            entityId: proj.entityId || "",
            isActive: proj.isActive ?? true
        });
        setEditMode(true);
        setCurrentId(proj.id);
        setIsModalOpen(true);
    };

    const handleDelete = (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce projet ?")) {
            dispatch(deleteProjetRequest(id));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (editMode) {
            dispatch(updateProjetRequest(currentId, formData));
        } else {
            dispatch(createProjetRequest(formData));
        }
        setIsModalOpen(false);
    };

    return (
        <div style={{ marginTop: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, padding: '0 18px' }}>
                <div>
                    <h2 style={{ margin: 0, color: 'var(--admin-primary)', fontSize: 18 }}>Liste des Projets</h2>
                    <p style={{ margin: '5px 0 0 0', fontSize: 13, color: '#6b7280' }}>Gérez les projets de l'entreprise</p>
                </div>
                <button className="jtBtn jtBtn--primary" onClick={openCreateModal}>
                    <Plus size={16} /> Nouveau Projet
                </button>
            </div>

            <div className="jtGrid" style={{ gridTemplateColumns: '1fr', padding: '0 18px' }}>
                <div className="jtCard" style={{ padding: 0, overflow: 'hidden' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 13 }}>
                        <thead>
                            <tr style={{ borderBottom: '1px solid #e5e7eb', backgroundColor: '#f9fafb', color: '#374151' }}>
                                <th style={{ padding: '12px 16px', fontWeight: 600 }}>Code</th>
                                <th style={{ padding: '12px 16px', fontWeight: 600 }}>Nom</th>
                                <th style={{ padding: '12px 16px', fontWeight: 600 }}>Description</th>
                                <th style={{ padding: '12px 16px', fontWeight: 600 }}>Entité</th>
                                <th style={{ padding: '12px 16px', fontWeight: 600 }}>Statut</th>
                                <th style={{ padding: '12px 16px', fontWeight: 600, textAlign: 'right' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {allProjets.map(p => (
                                <tr key={p.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                    <td style={{ padding: '12px 16px', fontWeight: 500 }}>{p.code}</td>
                                    <td style={{ padding: '12px 16px' }}>{p.nom}</td>
                                    <td style={{ padding: '12px 16px', color: '#6b7280' }}>{p.description || "-"}</td>
                                    <td style={{ padding: '12px 16px' }}>{p.entityNom || p.entityName || p.entiteNom || p.entiteName || "-"}</td>
                                    <td style={{ padding: '12px 16px' }}>
                                        <span style={{
                                            padding: '4px 8px', 
                                            borderRadius: 12,
                                            fontSize: 11,
                                            fontWeight: 600,
                                            background: p.isActive ? '#dcfce7' : '#fee2e2',
                                            color: p.isActive ? '#166534' : '#991b1b'
                                        }}>
                                            {p.isActive ? "Actif" : "Inactif"}
                                        </span>
                                    </td>
                                    <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                                        <button className="jtIconBtn" onClick={() => openEditModal(p)} style={{ color: '#2563eb', marginRight: 5 }} title="Modifier">
                                            <Edit2 size={16} />
                                        </button>
                                        <button className="jtIconBtn" onClick={() => handleDelete(p.id)} style={{ color: '#dc2626' }} title="Supprimer">
                                            <Trash2 size={16} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {allProjets.length === 0 && !loading && (
                                <tr>
                                    <td colSpan="6" style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>
                                        Aucun projet trouvé.
                                    </td>
                                </tr>
                            )}
                            {loading && (
                                <tr>
                                    <td colSpan="6" style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>
                                        Chargement des projets...
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {isModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
                    <div style={{ background: '#fff', padding: 24, borderRadius: 8, width: 450, maxWidth: '90%', boxShadow: '0 10px 25px rgba(0,0,0,0.1)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                            <h3 style={{ margin: 0, color: 'var(--admin-primary)' }}>{editMode ? "Modifier le Projet" : "Nouveau Projet"}</h3>
                            <button onClick={() => setIsModalOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280' }}><X size={20}/></button>
                        </div>
                        
                        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                            <div style={{ display: 'flex', gap: 12 }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ display: 'block', fontSize: 13, marginBottom: 5, fontWeight: 500, color: '#374151' }}>Code *</label>
                                    <input required type="text" value={formData.code} onChange={e => setFormData({...formData, code: e.target.value})} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} placeholder="Ex: PRJ-001" />
                                </div>
                                <div style={{ flex: 2 }}>
                                    <label style={{ display: 'block', fontSize: 13, marginBottom: 5, fontWeight: 500, color: '#374151' }}>Nom du projet *</label>
                                    <input required type="text" value={formData.nom} onChange={e => setFormData({...formData, nom: e.target.value})} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14 }} placeholder="Nom complet" />
                                </div>
                            </div>
                            
                            <div>
                                <label style={{ display: 'block', fontSize: 13, marginBottom: 5, fontWeight: 500, color: '#374151' }}>Description</label>
                                <textarea value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, resize: 'vertical' }} rows={3} placeholder="Description optionnelle" />
                            </div>
                            
                            <div>
                                <label style={{ display: 'block', fontSize: 13, marginBottom: 5, fontWeight: 500, color: '#374151' }}>Entité associée *</label>
                                <select required value={formData.entityId} onChange={e => setFormData({...formData, entityId: e.target.value})} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, backgroundColor: '#fff', color: '#374151' }}>
                                    <option value="" style={{ color: '#374151', backgroundColor: '#fff' }}>Sélectionnez une entité</option>
                                    {entites.map(e => (
                                        <option key={e.id} value={e.id} style={{ color: '#374151', backgroundColor: '#fff' }}>{getEntityLabel(e)}</option>
                                    ))}
                                </select>
                            </div>
                            
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4 }}>
                                <input type="checkbox" id="isActive" checked={formData.isActive} onChange={e => setFormData({...formData, isActive: e.target.checked})} style={{ width: 16, height: 16 }} />
                                <label htmlFor="isActive" style={{ fontSize: 14, color: '#374151', cursor: 'pointer' }}>Projet actif (visible pour la saisie des temps)</label>
                            </div>
                            
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 15, paddingTop: 15, borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={() => setIsModalOpen(false)} style={{ padding: '8px 16px', background: '#f3f4f6', color: '#4b5563', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 500 }}>Annuler</button>
                                <button type="submit" style={{ padding: '8px 16px', background: 'var(--admin-accent)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 500 }}>{editMode ? "Mettre à jour" : "Créer le projet"}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
